import footerImage from "./footerImage.svg";

export default {
  footerImage,
};
